import Vue from 'vue'
import Vuex from 'vuex'
import demoCompanies from '@/assets/data/companies.json'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    accountCompany: {},
    accounts: [],
    activeAccount: {},
    activeAccountTrailers: [],
    activeAccountSession: {},
    companies: demoCompanies?.sort((a, b) => a?.name?.localeCompare(b?.name)) || [],
    isAuth: false,
    selectedTrailers: [],
    snackbar: {
      color: 'success',
      message: '',
      show: false
    },
    trailerMap: {}
  },
  getters: {},
  actions: {
    setActiveAccount({ commit }, accountData = {}) {
      commit('COMMIT_ACTIVE_ACCOUNT', accountData)
    },
    setActiveAccountTrailers({ commit }, trailers = []) {
      commit('COMMIT_ACTIVE_ACCOUNT_TRAILERS', trailers)
    },
    setActiveAccountSession({ commit }, sessionData = {}) {
      commit('COMMIT_ACTIVE_ACCOUNT_SESSION', sessionData)
    },

    setIsAuth({ commit }, isAuth) {
      commit('COMMIT_IS_AUTH', isAuth)
    },
    setAccountCompany({ commit }, companyData) {
      commit('COMMIT_ACCOUNT_COMPANY', companyData)
    },

    setSelectedTrailers({ commit }, trailers) {
      commit('COMMIT_SELECTED_TRAILERS', trailers)
    },
    setTrailerMap({ commit }, trailers) {
      commit('COMMIT_TRAILER_MAP', trailers)
    },
    triggerSnackbar({ commit }, values = {}) {
      const defaultValues = {
        color: 'success',
        message: '',
        show: Boolean(values.message)
      }
      const snackbarValues = { ...defaultValues, ...values }
      commit('COMMIT_SNACKBAR', snackbarValues)
    }
  },
  mutations: {
    COMMIT_ACCOUNT_COMPANY(state, data = {}) {
      state.accountCompany = { ...data }
    },
    COMMIT_ACTIVE_ACCOUNT(state, data = {}) {
      state.activeAccount = { ...data }
    },
    COMMIT_ACTIVE_ACCOUNT_TRAILERS(state, trailers = []) {
      if (!trailers) trailers = []
      state.activeAccountTrailers = [...trailers]
    },
    COMMIT_ACTIVE_ACCOUNT_SESSION(state, data = {}) {
      state.activeAccountSession = { ...data }
    },
    COMMIT_IS_AUTH(state, value) {
      state.isAuth = !!value
    },
    COMMIT_SELECTED_TRAILERS(state, trailers = []) {
      if (!Array.isArray(trailers)) {
        state.selectedTrailers = []
      } else {
        state.selectedTrailers = trailers
      }
    },
    COMMIT_SNACKBAR(state, data = {}) {
      state.snackbar = { ...data }
    },
    COMMIT_TRAILER_MAP(state, data = {}) {
      state.trailerMap = { ...data }
    }
  }
})
